/**
 * Starts the unranged reason owa-backend gives a product that the
 * "leave slow movers out" floor (`range.min_candidate_quantity`) kept out of
 * the pogger request. Keep in step with `SLOW_MOVER_REASON_PREFIX` in
 * owa-backend `helpers/slowMovers.ts`.
 */
export const SLOW_MOVER_REASON_PREFIX = "Left out as a slow mover";

/** Whether the slow-mover floor, not pogger, is why this item is unranged. */
export const isLeftOutAsSlowMover = (item: { reasons: readonly string[] }) =>
  item.reasons.some((reason) => reason.startsWith(SLOW_MOVER_REASON_PREFIX));
